export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25')
];

export const server_loads = [];

export const dictionary = {
		"/(app)": [6,[2]],
		"/(app)/admin": [7,[2,3]],
		"/(app)/admin/settings": [8,[2,3]],
		"/(app)/admin/userInfo": [9,[2,3]],
		"/auth": [23],
		"/(app)/c/[id]": [10,[2]],
		"/error": [24],
		"/(app)/playground": [11,[2,4]],
		"/s/[id]": [25],
		"/(app)/workspace": [12,[2,5]],
		"/(app)/workspace/documents": [13,[2,5]],
		"/(app)/workspace/functions": [14,[2,5]],
		"/(app)/workspace/managed-collections": [15,[2,5]],
		"/(app)/workspace/models": [16,[2,5]],
		"/(app)/workspace/models/create": [17,[2,5]],
		"/(app)/workspace/models/edit": [18,[2,5]],
		"/(app)/workspace/prompts": [19,[2,5]],
		"/(app)/workspace/prompts/create": [20,[2,5]],
		"/(app)/workspace/prompts/edit": [21,[2,5]],
		"/(app)/workspace/tools": [22,[2,5]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
};

export { default as root } from '../root.svelte';